import React from "react";

import DataPickerAtualizado from "../../../../../components/DataPickerAtualizado";
import Button from "../../../../../componentsv2/Button";
import Paper from "../../../../../componentsv2/Paper";

export default function FiltrosRelatorios({
  dataInicial,
  setDataInicial,
  dataFinal,
  setDataFinal,
  onAplicarFiltros,
}) {
  return (
    <Paper style={{ marginTop: "12px", padding: "20px", borderRadius: "12px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          <div style={{ width: "220px" }}>
            <DataPickerAtualizado
              data={dataInicial}
              setData={setDataInicial}
              variant="standard"
              labelName="Data inicial"
            />
          </div>
          <div style={{ width: "220px" }}>
            <DataPickerAtualizado
              data={dataFinal}
              setData={setDataFinal}
              variant="standard"
              labelName="Data final"
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button type="button" variant="contained" color="blue" onClick={onAplicarFiltros}>
            Aplicar filtros
          </Button>
        </div>
      </div>
    </Paper>
  );
}
